import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(
    JSON.parse(localStorage.getItem("authClient")) || null
  );

  useEffect(() => {
    if (authUser) {
      localStorage.setItem("authClient", JSON.stringify(authUser));
    } else {
      localStorage.removeItem("authClient");
    }
  }, [authUser]);

  const removeAuth = () => {
    setAuthUser(null);
    localStorage.removeItem("authClient");
  };

  return (
    <AuthContext.Provider value={{ authUser, setAuthUser, removeAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
